module.exports = "<div class=\"container-fluid kill-left-side margin-top-20\">\r\n\r\n    <div class=\"row\">\r\n\r\n            <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 kill-right-side\">\r\n                    <scatterplot></scatterplot>\r\n            </div>\r\n\r\n    </div>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/section-page/section-page.html
// module id = 92
// module chunks = 0